module.exports = __webpack_public_path__ + "media/images/arrow-right-46b067bf43bbaf1448f4fea8b39a1ae6.svg";